import { NgModule } from '@angular/core';
import { CommonModule, NgFor, NgIf, NgStyle } from '@angular/common';
import { AppMaterialModule } from './app-material/app-material.module';
import { RouterLink } from '@angular/router';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    NgFor,
    NgIf,
    AppMaterialModule,
    RouterLink
  ],
  exports:[
    CommonModule,
    NgFor,
    NgIf,
    AppMaterialModule,
    RouterLink
  ],
  providers: []

})
export class SharedModule { }
